const chartjs = require('../../../../../../components/chart/chartjs')
const { changeSVG } = require('../../../../../../js-handler/graphic')
const settings = require('../../../../../../js-handler/settings')

let barSimpleChart = null;

export function createChart(parameter) {
    const canvas = document.getElementById('chartBarClientActivity');
    const companiesName = document.getElementById('companiesName');
    const desc = document.querySelector('#page-right-desc-chart-activity');

    if (!canvas) {
        console.log('Canvas chartBarClientActivity no encontrado');
        return;
    }

    if (companiesName) {
        companiesName.textContent = `${settings.getData().name} and ${settings.getData().company}`;
    }

    if (desc) {
        const param = settings.getData();
        if(param.entity === "clientCustomer"){
            desc.textContent = `
                This shows all sales that our company "${settings.getData().company}" has made to you "${settings.getData().name}". 
                The amounts reflect your accounts payable: the money still owed for the goods or services we have provided to you.
            `;
        }else{
            desc.textContent = `
                This shows the purchases our company "${settings.getData().company}" has made from your business "${settings.getData().name}". 
                The amounts reflect our accounts payable to you: the money we owe you as a supplier for the products or services provided.
            `;
        }
    }

    // Destruye el gráfico anterior si existe para evitar superposiciones
    if (barSimpleChart) {
        barSimpleChart.destroy();
        barSimpleChart = null;
    }

    // Helper para limpiar el formato de moneda ($14,075.00 -> 14075.00)
    const parseCurrency = (value) => parseFloat((value || '0').replace(/[^0-9.-]+/g, ""));

    // 1. Extraer montos del array de respuesta
    const row = parameter[0] || {};
    const current = parseCurrency(row.grand_total_current);
    const total_30 = parseCurrency(row.grand_total_due_30_days);
    const total_31_60 = parseCurrency(row.grand_total_due_31_to_60_days);
    const total_61_90 = parseCurrency(row.grand_total_due_61_to_90_days);
    const total_over_90 = parseCurrency(row.grand_total_due_over_90_days);

    // 2. Determinar si es Customer o Provider para la última etiqueta/total
    const isCustomer = settings.getData().entity === 'clientCustomer';
    const totalLabel = isCustomer ? "Total Payable" : "Total Receivable";
    const totalValue = isCustomer ? parseCurrency(row.total_sale) : parseCurrency(row.total_purchase);
    const datasetLabel = isCustomer ? "Accounts Payable" : "Accounts Receivable";

    // 3. Prepara los datos para el gráfico siguiendo la secuencia indicada
    const chartData = {
        labels: ['Current', '0-30 days', '31-60 days', '61-90 days', 'over 90 days', totalLabel],
        dataset: [
            {
                label: datasetLabel,
                backgroundColor: ['#36A2EB', '#4bc0c0', '#ffcd56', '#f86624', '#ff2857', '#f36cde'],
                data: [current, total_30, total_31_60, total_61_90, total_over_90, totalValue],
            }
        ]
    };

    // 4. Iniciar Chart.js
    barSimpleChart = chartjs.start({
        elem: 'bar',
        act: 'createMultipleLineWithLabels',
        targetChart: { html: canvas },
        data: chartData,
        options: {
            aspectRatio: 10 / 4.1,
            legend: false
        }
    });
}